import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DELETE, GET, POST, PUT } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";

export const createOrderAddress = createAsyncThunk(
  "create-order-addrress",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await POST(API.ORDER_ADDRESS, data);
      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const EditOrderAddress = createAsyncThunk(
  "create-order-addrress",
  async ({ id, data }, { rejectWithValue }) => {
    console.log(id, data, "dddddadsadaddsadad");

    try {
      const response = await PUT(`${API.ORDER_ADDRESS}/${id}`, data);

      if (response?.data?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const OrderResponse = createAsyncThunk(
  "order-response",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(`${API.ORDER}/payment-status`, data);

      if (response?.success) {
        return response;
      } else {
        return rejectWithValue(response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllOrderAddress = createAsyncThunk(
  "get-order-addrress",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GET(API.ORDER_ADDRESS);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllSippingOrderAddress = createAsyncThunk(
  "get-sipping-order-addrress",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GET(API.ORDER_ADDRESS + `/${"shipping"}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSingleOrderAddress = createAsyncThunk(
  "get-order-address-single",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await GET(API.ORDER_ADDRESS + `/${id}`);

      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteAddress = createAsyncThunk(
  "delete-address",
  async (id, { rejectWithValue }) => {
    try {
      const response = await DELETE(API.ORDER_ADDRESS + `/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Thunk for getting all CARTS
export const createOrder = createAsyncThunk(
  "create-order",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(API.ORDER, data);
      console.log(response, "response response");

      if (response?.success) {
        return response;
      } else {
        return rejectWithValue(response.errors);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting all CARTS
export const getAllOrder = createAsyncThunk(
  "get-all-orders",
  async ({ order_status_id = "" }, { rejectWithValue }) => {
    try {
      const response = await GET(
        API.ORDER + `?order_status_id=${order_status_id || ""}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllOrderDeliver = createAsyncThunk(
  "get-all-orders-deliver",
  async ({ order_status_id = "" }, { rejectWithValue }) => {
    try {
      const response = await GET(
        API.ORDER + `?order_status_id=${order_status_id || ""}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetallRejectedOrders = createAsyncThunk(
  "get-all-orders-rejected",
  async ({ order_status_id = "" }, { rejectWithValue }) => {
    try {
      const response = await GET(
        API.ORDER + `?order_status_id=${order_status_id || ""}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllReturnedOrder = createAsyncThunk(
  "get-all-Returned-orders",
  async ({ order_status_id = "" }, { rejectWithValue }) => {
    try {
      const response = await GET(
        API.ALL_RETURN + `?order_status_id=${order_status_id || ""}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllCancelledOrder = createAsyncThunk(
  "get-all-Cancelled-orders",
  async ({ order_status_id = "" }, { rejectWithValue }) => {
    try {
      const response = await GET(
        API.ALL_CANCEL + `?order_status_id=${order_status_id || ""}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting CART
export const getOrder = createAsyncThunk(
  "get-order",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(API.ORDER + `/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCanceledOrder = createAsyncThunk(
  "get-cancel-order",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(API.SINGLE_CANCEL + `/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getReturnedOrder = createAsyncThunk(
  "get-return-order",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(API.SINGLE_RETURN + `/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for getting CART
export const cancelOrder = createAsyncThunk(
  "cancel-order",
  async ({ order_id, data }, { rejectWithValue }) => {
    try {
      console.log("datd hererer", order_id, data);

      const response = await POST(API.ORDER_CANCEL + `/${order_id}`, data);
      return response;
    } catch (error) {
      console.error("Cancel order failed:", error);
      return rejectWithValue(
        error.response?.data || error.message || "Something went wrong"
      );
    }
  }
);

// Thunk for getting CART
export const returnOrder = createAsyncThunk(
  "return-order",
  async ({ order_id, data }, { rejectWithValue }) => {
    console.log(order_id, data, " order_id, DataToSend ");

    try {
      const response = await POST(API.ORDER_RETURN + `/${order_id}`, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createOrderMessage = createAsyncThunk(
  "create-order-message",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(API.ORDER + `/message`, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getOrderMessage = createAsyncThunk(
  "get-order-message",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(API.ORDER + `/message/data`);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const CouponApplyed = createAsyncThunk(
  "coupon-applyed",
  async ({data}, { rejectWithValue }) => {
    try {
      const response = await POST(API.COUPON_APPLYED, data);

      console.log(response,"response response");
      
      if (response?.success) {
        return response;
      }
     return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const postReorder = createAsyncThunk(
  "postReorder",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(API.REORDER + `/${id}`);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// export const getCoupons = createAsyncThunk(
//   "get-coupon",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await GET(API.COUPON);
//       return response;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const OrderCalculation = createAsyncThunk(
  "order-calculation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(API.ORDER_CALCULATION, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const handleAsyncState = (state, action, isSignin = false) => {
  switch (action.type) {
    case "pending":
      state.status = "loading";
      break;
    case "fulfilled":
      state.status = "succeeded";
      if (isSignin) {
        state.token = action.payload;
        state.is_signin = true;
      }
      break;
    case "rejected":
      state.status = "failed";
      state.error = action.payload;
      if (isSignin) state.is_signin = false;
      break;
    default:
      return state;
  }
};

// Create the slice
const orderSlice = createSlice({
  name: "order",
  initialState: {
    allOrders: [],
    allOrdersDeliver: [],
    allOrdersAddress: [],
    allReturnedOrders: [],
    allRejectedOrders: [],
    allCancelledOrders: [],
    allSppingOrdersAddress: [],
    orderAddress: {},
    order: {},
    orderMessage: [],
    all_coupons: [],
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "createOrder Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllOrder.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allOrders = action.payload?.data || [];
        console.log(
          "getAllOrder Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(getAllOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

        .addCase(GetallRejectedOrders.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(GetallRejectedOrders.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allRejectedOrders = action.payload?.data || [];
        console.log(
          "getAllOrder Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(GetallRejectedOrders.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllOrderDeliver.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllOrderDeliver.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allOrdersDeliver = action.payload?.data || [];
        console.log(
          "getAllOrder Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(getAllOrderDeliver.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllReturnedOrder.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllReturnedOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allReturnedOrders = action.payload?.data || [];
        console.log(
          "getAllReturnedOrder Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(getAllReturnedOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllCancelledOrder.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllCancelledOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allCancelledOrders = action.payload?.data || [];
        console.log(
          "getAllReturnedOrder Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(getAllCancelledOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getOrder.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "getOrder Response payload in fulfilled case:",
          action.payload
        );
        state.order = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getReturnedOrder.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getReturnedOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "getReturnedOrder Response payload in fulfilled case:",
          action.payload
        );
        state.order = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getReturnedOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getCanceledOrder.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getCanceledOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "getCanceledOrder Response payload in fulfilled case:",
          action.payload
        );
        state.order = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getCanceledOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(cancelOrder.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "cancelOrder Response payload in fulfilled case:",
          action.payload.data
        );
        console.log("cancelOrder State after fulfilled", state);
      })
      .addCase(cancelOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(returnOrder.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(returnOrder.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "returnOrder Response payload in fulfilled case:",
          action.payload.data
        );
        console.log("returnOrder State after fulfilled", state);
      })
      .addCase(returnOrder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(createOrderAddress.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(createOrderAddress.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "createOrder Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(createOrderAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllOrderAddress.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllOrderAddress.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allOrdersAddress = action.payload || [];
        console.log(
          "getAllOrder Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(getAllOrderAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllSippingOrderAddress.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllSippingOrderAddress.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allSppingOrdersAddress = action.payload || [];
        console.log(
          "getAllOrder Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(getAllSippingOrderAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getSingleOrderAddress.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getSingleOrderAddress.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.orderAddress = action.payload?.data || {};
        console.log(
          "getOrder single Response payload in fulfilled case:",
          action.payload
        );
        console.log("single prder after fulfilled", state.orderAddress);
      })
      .addCase(getSingleOrderAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(deleteAddress.pending, (state) => {
        state.status = "loading";
        console.log("postCartQuantity State after pending", state);
      })
      .addCase(deleteAddress.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          " postCartQuantity Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(deleteAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("postCartQuantity State after rejected", state);
      })
      .addCase(createOrderMessage.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(createOrderMessage.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "createOrder Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(createOrderMessage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })
      .addCase(getOrderMessage.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getOrderMessage.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "getOrder Response payload in fulfilled case:",
          action.payload
        );
        state.orderMessage = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getOrderMessage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(CouponApplyed.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true)
      )
      .addCase(CouponApplyed.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true
        )
      )
      .addCase(CouponApplyed.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true
        )
      )

      .addCase(OrderCalculation.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true)
      )
      .addCase(OrderCalculation.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true
        )
      )
      .addCase(OrderCalculation.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true
        )
      )

      .addCase(postReorder.pending, (state) => {
        state.status = "loading";
      })
      .addCase(postReorder.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(postReorder.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })


      .addCase(OrderResponse.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true)
      )
      .addCase(OrderResponse.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true
        )
      )
      .addCase(OrderResponse.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true
        )
      )
    //   .addCase(getCoupons.pending, (state) => {
    //   state.status = "loading";
    //   console.log("State after pending", state);
    // })
    // .addCase(getCoupons.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.all_coupons = action.payload?.data || [];
    //   console.log(
    //     "getAllOrder Response payload in fulfilled case:",
    //     action.payload
    //   );
    //   console.log("State after fulfilled", state);
    // })
    // .addCase(getCoupons.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    //   console.log("State after rejected", state);
    // })
  },
});

export default orderSlice.reducer;
